<template>
  <div class="content">
    <!-- tab页 -->
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <!-- 到期设备查询 -->
      <el-tab-pane name="deadline">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 到期设备查询
        </span>
        <!-- 后端分页 -->
        <!-- <div class="tableWrapper" v-loading="!showTable">
          <easyTable
            apiUrl="operation/device/expirelist"
            :parent="self"
            :config="config"
            :other="other"
            ref="deadline"
          >
          </easyTable>
        </div> -->
        <section class="easyTable" ref="easyTable">
          <el-table :data="tableData" class="stripeTable" style="width: 100%" v-loading="bLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" height="400">
            <el-table-column v-for="i of config" :key="i.prop" :label="i.label" :prop="i.prop"></el-table-column>
          </el-table>

          <div class="footer">
            <el-pagination :total="total" :page-size="pageSize" :current-page.sync="pageNum" @current-change="handleCurrentChange" layout="prev, pager, next"></el-pagination>
          </div>
        </section>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
  },
  data() {
    return {
      items: [],
      form_jsgl: {},
      showTable: true,
      tabName: 'deadline',
      bLoading: true,
      tableData: [],
      pageNum: 1,
      pageSize: 10,
      total: 10,
      seefrom: {
        deviceName: '',
      },
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'deviceName',
          label: '设备名称',
        },
        {
          prop: 'device_mark',
          label: '设备编码',
        },
        {
          prop: 'systemName',
          label: '应用系统',
        },
        {
          prop: 'deviceTypeName',
          label: '设备类型',
        },
        {
          prop: 'expire_time',
          label: '到期时间',
        },
      ]
    },
  },
  methods: {
    handleCurrentChange(val) {
      this.$axiosget('operation/device/expirelist', {
        params: {
          pageNum: val,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        this.tableData = res.data.data
        this.bLoading = false
      })
    },
    initdata() {
      this.$axiosget('operation/device/expirelist', {
        params: {
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        },
      }).then((res) => {
        this.tableData = res.data.data
        this.bLoading = false
      })
    },
  },
  mounted() {
    this.initdata()
  },
}
</script>

<style lang="less">
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/device/deadline.vue